/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderPredictionItem
 */
export interface OrderPredictionItem {
    /**
     * 
     * @type {string}
     * @memberof OrderPredictionItem
     */
    skuId: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPredictionItem
     */
    supplierId: string;
    /**
     * 
     * @type {number}
     * @memberof OrderPredictionItem
     */
    predictedSales: number;
    /**
     * 
     * @type {number}
     * @memberof OrderPredictionItem
     */
    currentStock?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderPredictionItem
     */
    minimumStock?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderPredictionItem
     */
    inTransit?: number;
}

/**
 * Check if a given object implements the OrderPredictionItem interface.
 */
// @ts-ignore
export function instanceOfOrderPredictionItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "skuId" in value;
    isInstance = isInstance && "supplierId" in value;
    isInstance = isInstance && "predictedSales" in value;

    return isInstance;
}

// @ts-ignore
export function OrderPredictionItemFromJSON(json: any): OrderPredictionItem {
    return OrderPredictionItemFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderPredictionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderPredictionItem {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'skuId': json['sku_id'],
        'supplierId': json['supplier_id'],
        'predictedSales': json['predicted_sales'],
        'currentStock': !exists(json, 'current_stock') ? undefined : json['current_stock'],
        'minimumStock': !exists(json, 'minimum_stock') ? undefined : json['minimum_stock'],
        'inTransit': !exists(json, 'in_transit') ? undefined : json['in_transit'],
    };
}

// @ts-ignore
export function OrderPredictionItemToJSON(value?: OrderPredictionItem | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sku_id': value.skuId,
        'supplier_id': value.supplierId,
        'predicted_sales': value.predictedSales,
        'current_stock': value.currentStock,
        'minimum_stock': value.minimumStock,
        'in_transit': value.inTransit,
    };
}

